import { useCallback, useMemo, useState } from 'react';
import api from '../../services/api';

const safeLocalStorage = {
  get(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  },
  set(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      // ignore storage access issues
    }
  }
};

const getSessionId = () => {
  const existing = safeLocalStorage.get('supportSessionId');
  if (existing) return existing;
  const next = `support-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  safeLocalStorage.set('supportSessionId', next);
  return next;
};

const starterMessages = [
  {
    role: 'assistant',
    content: 'Merhaba, ben TahminArena canli destek hattindayim. Premium uyelik, analizler veya site kullanimi konusunda yardimci olabilirim.'
  }
];

export const useLiveSupport = ({ user, isPremium }) => {
  const [messages, setMessages] = useState(starterMessages);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');
  const [supportConfig, setSupportConfig] = useState({ whatsappLink: '', whatsappEnabled: false, adminEmail: '' });
  const [leadSaving, setLeadSaving] = useState(false);
  const sessionId = useMemo(() => getSessionId(), []);

  const canPromotePremium = useMemo(() => !isPremium, [isPremium]);

  const loadSupportConfig = useCallback(async () => {
    try {
      const data = await api.getSupportConfig();
      setSupportConfig(data);
    } catch (err) {
      setSupportConfig({ whatsappLink: '', whatsappEnabled: false, adminEmail: '' });
    }
  }, []);

  const sendMessage = async (content, page) => {
    const trimmed = String(content || '').trim();
    if (!trimmed) return;

    const nextMessages = [...messages, { role: 'user', content: trimmed }];
    setMessages(nextMessages);
    setSending(true);
    setError('');

    try {
      const data = await api.sendSupportMessage({
        sessionId,
        message: trimmed,
        messages: nextMessages,
        meta: {
          userName: user?.name,
          isPremium,
          page
        }
      });

      setMessages((current) => [...current, { role: 'assistant', content: data.reply }]);
    } catch (err) {
      setError(err.message);
      setMessages((current) => [
        ...current,
        {
          role: 'assistant',
          content: 'Su an kisa bir gecikme oldu. Birazdan tekrar deneyin ya da canli destek ayarlarindan iletisim kanalini kullanin.'
        }
      ]);
    } finally {
      setSending(false);
    }
  };

  const saveLead = async ({ email, name }) => {
    setLeadSaving(true);
    setError('');
    try {
      const data = await api.saveSupportLead({ sessionId, email, name });
      setMessages((current) => [...current, { role: 'assistant', content: data.message }]);
    } catch (err) {
      setError(err.message);
    } finally {
      setLeadSaving(false);
    }
  };

  return {
    messages,
    sending,
    error,
    canPromotePremium,
    supportConfig,
    leadSaving,
    sendMessage,
    saveLead,
    loadSupportConfig
  };
};
